namespace app.documentos {

    import IDirective = angular.IDirective;
    import IDirectiveFactory = angular.IDirectiveFactory;
    import IScope = angular.IScope;
    import IPromise = angular.IPromise;


    export interface EditorApi {
        salvar(): IPromise<any>;
        plugin(name: string): OnlyofficePluginApi;
    }

    export interface EditorDocumento {
        id?: number | string;
        textoId?: number;
        nome: string;
        temporario?: boolean;
    }

    export interface OnlyofficePlugin {
        id: string;
        autostart?: {guid: string};
    }
    
    export interface EditorScope extends IScope {
        api: EditorApi;
        documento: EditorDocumento;
        edicaoConcluida: Function;
        edicaoIniciada: Function;
        edicaoTimeout: Function;
        aguardarConclusao: any;
        editorHeight: string;
        save: boolean;
        showMaximize: boolean;
        contexto: string;
        readOnly: boolean;
        historyEnabled: boolean;
        plugins: OnlyofficePlugin[];
        callbackOmitToken: boolean;
        configOverride: DocsAPI.OnlyofficeConfig;
    }

    class EditorDirective implements IDirective {

        public restrict: string = 'AE';
        public templateUrl: string = 'app/main/documentos/directives/editor/editor.tpl.html';

        public scope: Object = {
            api: "=?",
            documento: "=onlyofficeEditor",
            edicaoConcluida: "&",
            edicaoIniciada: "&",
            edicaoTimeout: "&",
            aguardarConclusao: "@",
            editorHeight: "@",
            save: "=",
            showMaximizeButton: "=",
            contexto: "@",
            readOnly: "=readOnly",
            historyEnabled: "=historyEnabled",
            plugins: "=plugins",
            callbackOmitToken: "=",
            configOverride: "="
        };

        public controller: any = EditorController;
        public controllerAs: string = 'vm';

        constructor() {
            this.templateUrl = 'app/main/documentos/directives/editor/editor.tpl.html';
        }

        public static factory(): IDirectiveFactory {
            return () => {
                return new EditorDirective();
            };
        }

    }

    angular.module('app.documentos').directive('onlyofficeEditor', EditorDirective.factory());
}